import React from 'react';
import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';
import { cn } from 'lib/utils';

/**
 * inline spinner for a fetch that happens while rows are already on screen —
 * paging, a background revalidation, or an automatic retry. it never replaces
 * content, so the user keeps seeing the previous page while the next one loads.
 * @param isRetrying - true while the request is being retried after a failure
 * @param className - extra classes for positioning
 */
export default function LoadingHint({ isRetrying = false, className }) {
  return (
    <span
      role='status'
      className={cn('flex items-center gap-1.5 text-xs text-grey', className)}
    >
      <Loader2 className='size-3.5 animate-spin' aria-hidden />
      {isRetrying ? 'Retrying…' : 'Loading…'}
    </span>
  );
}

LoadingHint.propTypes = {
  isRetrying: PropTypes.bool,
  className: PropTypes.string
};
